export default "__VITE_ASSET__1645ca07__"